(ns vire.adserver.config
  (:require [cljs-http.client :as c]
            [cljs.core.async :as a]
            [cljs.reader :as edn]
            [clojure.string :as str]
            [storrito.state.core :as state])
  (:require-macros [cljs.core.async.macros :refer [go]]))

(defn server []
  js/location.origin)

(defn host []
  js/location.host)

(def debug?
  ^boolean js/goog.DEBUG)

;;; Enable `println` and others (in production as well as in
;;; dev-mode). Without this, `println` etc. will throw an error in
;;; minified builds and break the application
(enable-console-print!)

(defn ^:export dev-mode []
  (js/console.warn "Enabling dev-mode!")
  (swap! state/state assoc :dev-mode true))

(when (= (.-hostname js/location) "localhost")
  (dev-mode))

(defn ^:export dev-mode? []
  (true? (:dev-mode @state/state)))
